import { colors } from 'ui/theme';
import { CustomNode } from '../../../types';

export const MISC_ACCENT_COLOR = colors.flamingo100;
export const MISC_BACKGROUND_ACCENT_COLOR = colors.flamingo100;
export const MISC_BORDER_ACCENT_COLOR = colors.flamingo100;
export const MISC_DEFAULT_TITLE = 'Perform Action';

export const miscBaseConfig: CustomNode = {
  getCustomConfig(model) {
    return {
      defaultTitle: MISC_DEFAULT_TITLE,
      accentColor: MISC_ACCENT_COLOR,
      activeBorderColor: MISC_BORDER_ACCENT_COLOR,
      accentColorBackground: MISC_BACKGROUND_ACCENT_COLOR,
      ...this.getNodeConfig(model),
    };
  },

  getNodeConfig() {
    return {};
  },
};
